import { render, staticRenderFns } from "./quality-report-preview.vue?vue&type=template&id=126c7f18&scoped=true"
import script from "./quality-report-preview.vue?vue&type=script&lang=js"
export * from "./quality-report-preview.vue?vue&type=script&lang=js"
import style0 from "./quality-report-preview.vue?vue&type=style&index=0&id=126c7f18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c7f18",
  null
  
)

export default component.exports